import React, { useEffect, useRef, useState } from "react";
import AuthService from "../../Components/auth/AuthService";
import { hideLoading, showLoading, useLoadingDispatch } from "../../context/loadingContext";
import Message from "../../Components/common/Message";
import { Table, Button, Flex, InputNumber, Modal, Input, Divider, Typography, message, Row, Col, DatePicker, Tooltip, Image, Tag, Checkbox, Descriptions } from "antd";
import { ArrowLeftOutlined, CalendarOutlined, DeleteFilled, ExportOutlined, FileDoneOutlined, InfoCircleFilled, InfoCircleOutlined, InfoCircleTwoTone, NumberOutlined, TagOutlined, UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import ScanInput from "../Scan/ScanInput";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import moment from "moment";
import { env, wms_uploads_cdn } from "../../Components/config";
import { margin, style } from "@mui/system";
import ScanSelect from "../Scan/ScanSelect";
import { showMessage } from "../../Components/Utils/message";
import './dashboard.css'
import ProductInfoModal from "../../Components/Modals/ProductInfoModal";
import ProductScanSelect from "../Scan/ProductScanSelect";
import CustomTag from "../../Components/CustomTag";
import InfoCards from "../../Components/InfoCards";
import LocationInfoModal from "../../Components/Modals/LocationInfoModal";
import DetailsGrid from "../../Components/common/DetailsGrid";

const NewStock = () => {
  const { locations, products } = useSelector((state) => state?.AppState?.userCreds);
  let layoutDispatch = useLoadingDispatch();
  const Auth = new AuthService();
  const navigate = useNavigate()
  const { Text } = Typography;
  const [documentNumber, setDocumentNumber] = useState("");
  const [recievedData, setRecievedData] = useState([]);

  const [modalVisible, setModalVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [newStock, setNewStock] = useState({
    product: "",
    product_id: '',
    location: "",
    location_id: null,
    quantity: "",
    productText: '',
    locationText: '',
    productStatus: null,
    locationStatus: null,
    expiry_date: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
    fullPallet: false,
    fullPalletShow: false,
    remainQtyShow: false,
    remaining_quantity_check: false
  });

  const [selectedProductLocations, setSelectedProductLocations] = useState([])
  const [allLocations, setAllLocations] = useState([])
  const [selectedLocations, setSelectedLocations] = useState([])
  const [stockTransactions, setStockTransactions] = useState([])
  const [posted, setPosted] = useState(false);
  const [detailsPO, setDetailsPO] = useState(null);
  const productRef = useRef(null);
    useEffect(() => {
      if (modalVisible) {
        setTimeout(() => {
          productRef.current?.focus();
        }, 100);
      }
    }, [modalVisible]);

  const handleSelect = async (record) => {
    showLoading(layoutDispatch)

    const dataToSend = {
      transaction_id: record?.internal_id,
      transaction_type: 1,
      purchase_order_details_batch_id: record?.purchase_order_details_batch_id,
      product_netsuite_id: record?.product_netsuite_id
    }

    try {
      const res = await Auth.fetch(`/stock/new-stock-detail`, {
        method: 'POST',
        body: JSON.stringify(dataToSend)
      });
      if (res?.ack) {
        const totalQuantityAdded = res?.stock_txns.reduce((sum, txn) => sum + (txn.quantity || 0), 0);
        const currentItemBatchId = res?.stock_txns[0]?.purchase_order_details_batch_id;
        const updatedRemainingQty = record?.batch_quantity - totalQuantityAdded;
        const updatedRecord = { ...record, remaining_quantity: updatedRemainingQty };
        const updatedReceivedData = recievedData.map(item => {
          if (item.purchase_order_details_batch_id === currentItemBatchId) {
            return { ...item, remaining_quantity: updatedRemainingQty, quantityAdded: totalQuantityAdded };
          }
          return item;
        });

      const selectedProduct = products?.find((pro) => pro?.netsuite_id == record?.product_netsuite_id);
      const selectedProductCasesInPallets = selectedProduct?.cases_in_pallets
      const capacityStaus = updatedRemainingQty >= selectedProductCasesInPallets ? true : false;
        if (capacityStaus) {
          setNewStock({ ...newStock, fullPalletShow: true, remainQtyShow: false})
        } else {
          setNewStock({ ...newStock, fullPalletShow: false, remainQtyShow: true})
        }
        setSelectedItem(updatedRecord);
        setRecievedData(updatedReceivedData)
        setStockTransactions(res?.stock_txns);
        // await getLocations();
        // setModalVisible(true);
        const hasLocations = await getLocations();
      if (hasLocations) {
        setModalVisible(true);
      } else {
        showMessage("error", "No locations available");
      }
      } else {
        showMessage('err', res?.message)
        setStockTransactions([])
      }
    } catch (err) {
      console.log(err);
      showMessage('error', 'something went wrong')
    } finally {
      hideLoading(layoutDispatch)
    }
  };

  const getLocations = async () => {
    showLoading(layoutDispatch)

    try {
      const res = await Auth.fetch(`/location/locations`);
      if (res?.ack) {
        console.log(res?.locations, 'locations');
          setSelectedLocations(res?.locations)
          // const sorted = res?.locations?.sort((a, b) => a.aisle.localeCompare(b.aisle));
          setAllLocations(res?.locations)
           return true; 
      } else {
        showMessage('err', res?.message)
        setSelectedLocations([])
         return false; 
      }
    } catch (err) {
      console.log(err);
      showMessage('error', 'something went wrong')
    } finally {
      hideLoading(layoutDispatch)
    }
  };

  const getLocationsDetails = async () => {
    const hasLocations = await getLocations();
      if (hasLocations) {
        setModalVisibleLocation(true);
      } else {
        showMessage("error", "No locations available");
      }
  }

  const handleValueChange = (value, isScanned) => {
    setDocumentNumber(value);
    if (isScanned) {
      handleSearch();
    }
  };
 
  const handleModalOk = async () => {
  if (!newStock?.location_id) return showMessage('error', 'Location is required');
  if (Number(newStock?.quantity) < 1) return showMessage('error', 'Quantity Must be greater than zero');

  const basePayload = {
    product_netsuite_id: newStock?.product_id,
    location_id: newStock?.location_id,
    quantity: newStock?.quantity,
    document_number: documentNumber,
    netsuite_transaction_id: selectedItem?.internal_id,
    purchase_order_details_batch_id: selectedItem?.purchase_order_details_batch_id,
    batch_code: selectedItem?.batch_code,
    expiry_date: newStock?.expiry_date,
    supplier_batch_code: selectedItem?.supplier_batch_code,
    purchase_order_id: selectedItem?.id,
    purchase_order_detail_id: selectedItem?.purchase_order_detail_id,
  };

  const submitStock = async (payload) => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch('/stock/new-stock', {
        method: 'POST',
        body: JSON.stringify(payload),
      });

      if (res?.ack) {
        showMessage('success', res?.message);
        setNewStock({
          product: "",
          product_id: '',
          location: "",
          location_id: '',
          quantity: "",
          productText: '',
          locationText: '',
          productStatus: null,
          locationStatus: null,
          expiry_date: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
          fullPallet: false,
          remaining_quantity_check: false,
          fullPalletShow: true
        });
        setModalVisible(false);
        handleSearch();
      } else {
        showMessage('error', res?.message);
        hideLoading(layoutDispatch);

        if (res?.capacity_increased_by) {
          const cases_in_pallets = products?.find(pro => pro?.netsuite_id == newStock?.product_id)?.cases_in_pallets || 0;
          const capcityCal = res?.capacity_increased_by * cases_in_pallets;
          const plusSignWithCapcity = capcityCal < 0 ? `${Math.abs(capcityCal)}` : capcityCal;
          if (plusSignWithCapcity >= cases_in_pallets) return showMessage('error', 'Please select another location, this location capacity is full');
          Modal.confirm({
            title: "Capacity Exceeded",
            content: (
              <div style={{ fontSize: 16 }}>
                Location capacity exceeded by{" "}
                <span style={{ color: "green", fontWeight: "bold", fontSize: 18 }}>
                  {Number(plusSignWithCapcity)?.toFixed(2)}
                </span>{" "}
                cases. Do you want to receive the stock anyway?
              </div>
            ),
            okText: "Yes",
            cancelText: 'Cancel',
            width: 600,
            okButtonProps: { size: "large" },
            cancelButtonProps: { size: "large" },
            onOk: () => submitStock({ ...payload, bypass_capacity_check: true }) 
          });
        }
      }
    } catch (err) {
      console.log(err);
      showMessage('error', 'Something went wrong');
      hideLoading(layoutDispatch);
    }
  };

  // First API call
  submitStock(basePayload);
};

  const handleModalCancel = () => {
    setNewStock({ product: "", product_id: '', location: "", location_id: null, quantity: "", productText: '', locationText: '', productStatus: null, locationStatus: null, expiry_date: new Date(new Date().setFullYear(new Date().getFullYear() + 1)), fullPallet: false, remaining_quantity_check: false, fullPalletShow: true })
    setModalVisible(false);
  };


  const handleSearch = async () => {
    setStockTransactions([])
    setRecievedData([])
    setPosted(false)
    setDetailsPO(null);

    if (!documentNumber?.trim()) {
      handleError("Please enter the Document Number.");
      return;
    }

    showLoading(layoutDispatch);

    try {
      const response = await Auth.fetch(`/stock/new-stock?po_number=${encodeURIComponent(documentNumber)}`);
      hideLoading(layoutDispatch);
      // const checkStatus = await Auth.fetch(`/stock/check-document-received?document_number=${documentNumber}&document_type=${1}`);
      if (response?.ack) {
        const allItems = response?.purchase_order;
        const updatedItems = allItems.map((item) => ({
          ...item,
          quantityAdded: Number(item.added_quantity) || 0,
          remaining_quantity: item?.batch_quantity - Number(item.added_quantity)
        }));
        setPosted(response?.purchase_order[0]?.posted_by > 0 ? true : false);
        setDetailsPO(response?.purchase_order[0]);
        setRecievedData(updatedItems ?? []);
      } else {
        handleError(response?.message);
      }
    } catch (error) {
      hideLoading(layoutDispatch);
      console.error("Error fetching purchase order:", error);
      handleError("An error occurred while fetching the data. Please try again.");
    }
  };


  // const handleSuccess = (data) => {
  //   setRecievedData(data);
  // };

  const handleError = (message) => {
    setRecievedData([]);
    showMessage('error', message)
    // setType("error");
    // setLoadMessage(message);
  };


 const [selectedProductDetails, setSelectedProductDetails] = useState({
      totalStock: 0,
      code: '',
      name: '',
      productDetails: []
    })
    const [locationDetails, setLocationDetails] = useState([])
    const [modalVisibleProduct, setModalVisibleProduct] = useState(false);
    const [modalVisibleLocation, setModalVisibleLocation] = useState(false);
    
    const handleModalCancelLocation = () => {
      setSelectedLocations([]);
      setAllLocations([])
      setModalVisibleLocation(false);
    }

    const handleModalCancelProduct = () => {
      setSelectedProductDetails({ ...selectedProductDetails, totalStock: 0, product: null, productDetails: [] });
      setModalVisibleProduct(false);
    }
    const handleInfoClick = async (record) => {
      const product = products?.find((item) => item?.netsuite_id == record?.product_netsuite_id);
      showLoading(layoutDispatch)
      try {
  
        const res = await Auth.fetch(`/product/product-details?id=${record?.product_netsuite_id}`)
        if (res?.ack) {
          if (res?.product_details.length > 0) {
            const totalStock = res.product_details.reduce((sum, item) => sum + (Number(item.stock_level) || 0), 0);
            setSelectedProductDetails({ ...selectedProductDetails, totalStock: totalStock, code: product?.code, name:product?.name, productDetails: res?.product_details });
            setModalVisibleProduct(true);
            hideLoading(layoutDispatch)
  
          } else {
            showMessage('error', 'No Details');
            hideLoading(layoutDispatch)
          }
        } else {
          setSelectedProductDetails({ ...selectedProductDetails, totalStock: 0, code: product?.code, name:product?.name, productDetails: [] });
          showMessage('error', res?.message)
          hideLoading(layoutDispatch)
  
        }
  
      } catch (error) {
        showMessage('error', 'something went wrong');
        hideLoading(layoutDispatch)
      }
    };


  const dataCol = [
    {
    title: "Sr No.",
    render: (_, __, index) => <span>{index + 1}</span>,
    width: 60, 
  },
    {
      title: "Item",
      sorter: (a, b) =>
      `${a?.product_code || ""} ${a?.product_name || ""}`.localeCompare(
        `${b?.product_code || ""} ${b?.product_name || ""}`
      ),
      render(record) {

        return (
          <Flex gap={5} align="center">
            <Tooltip title={'Product Info'}>

              <InfoCircleTwoTone style={{ fontSize: '16px', cursor: 'pointer' }} onClick={() => handleInfoClick(record)} />
            </Tooltip>
            <span>{`${record?.product_code} - ${record?.product_name}`}</span>

          </Flex>
        )

      }
    },
    {
      title: "Category",
      sorter: (a, b) => {
        const catA =
          products?.find((item) => item.netsuite_id == a?.product_netsuite_id)
            ?.sub_category || "";
        const catB =
          products?.find((item) => item.netsuite_id == b?.product_netsuite_id)
            ?.sub_category || "";
        return catA.localeCompare(catB);
      },
      render: (record) => {
        const item = products?.find((item) => item.netsuite_id == record?.product_netsuite_id);
        return (
          <span>{item?.sub_category ? item?.sub_category : '-'}</span>
        )
      }
    },
    {
      title: "Batch Code",
      render: (record) => {
        return (
          <span>{record?.batch_code ? record?.batch_code : '-'}</span>
        )
      }
    },
    {
      title: "Supplier Batch Code",
      sorter: (a, b) =>
        (a.supplier_batch_code || "").localeCompare(b.supplier_batch_code || ""),
      render: (record) => {
        return (
          <span>{record?.supplier_batch_code ? record?.supplier_batch_code : '-'}</span>
        )
      }
    },
    {
      title: 'Qty',
      sorter: (a, b) => (a.batch_quantity  || 0) - (b.batch_quantity  || 0),
      render: (record) => {
        return <span>{record?.batch_quantity?.toLocaleString() || '0'}</span>;
      },
    },
    
    {
      title: "Added Qty",
      sorter: (a, b) => (a.quantityAdded || 0) - (b.quantityAdded || 0),
      render: (record) => {
        return <Tag color='green' style={{ fontSize: 16, fontWeight: 'bold' }}>{Number(record?.quantityAdded)?.toLocaleString() || 0} </Tag>;
      },
    },
    {
      title: "Remaining Qty",
      sorter: (a, b) => (a.remaining_quantity || 0) - (b.remaining_quantity || 0),
      render: (record) => {
        return <Tag color={record?.remaining_quantity > 0 ? 'red' : 'blue'} style={{ fontSize: 16, fontWeight: 'bold' }}>{record?.remaining_quantity?.toLocaleString()}</Tag>;
      },
    },

    {
      title: "Action",
      align: "center",
      render: (record) => (
        <Tooltip title="Select Item">
          <ExportOutlined
            className="animated-select-icon"
            onClick={() => handleSelect(record)}
          />
        </Tooltip>
      ),
    }

  ];

  const isAnyQtyRemaining = (recievedData?.filter(
    (item) => (item?.batch_quantity - item?.quantityAdded) > 0
  )?.length > 0) || false;


  console.log('isAnyQtyRemaining', isAnyQtyRemaining);


  const transactionCol = [
  
    {
      title: "Location",
      render(record) {
        const location = locations?.find((loc) => loc.id == record?.location_id);
        return (
          <Flex gap={5} align="center">
            <span>{location?.code}</span>
          </Flex>
        )
      }
    },
    {
      title: 'Batch Code',
      dataIndex: 'batch_code',
      key: 'batch_code',
    },
    {
      title: 'Supplier Batch Code',
      dataIndex: 'supplier_batch_code',
      key: 'supplier_batch_code',
    },
    {
      title: "Qty",
      render(record) {
        return (
          <Flex gap={5} align="center">
            <Tag color='green' style={{ fontSize: 16, fontWeight: 'bold' }}>{Number(record?.quantity)?.toLocaleString() || 0} </Tag>
            {/* <span>{record?.quantity?.toLocaleString() || '0'}</span> */}
          </Flex>
        )
      }
    },
    {
      title: "User",
      render(record) {
        if (!record) return "";
    
        const user = record?.user_name || "";
        const helper = record?.helper_name || "";
    
        if (helper) {
          return (
            <>
              {helper}{" "}
              {user && (
                <Tooltip title={`${user}`}>
                  <InfoCircleOutlined style={{ fontSize: 16, marginLeft: 6, color: "#1890ff" }} />
                </Tooltip>
              )}
            </>
          );
        }
    
        return <>{user}</>;
      }
    },
    {
      title: "Created At",
      render(record) {
        return (
          <Flex gap={5} align="center">
            <span>{record?.createdAt ? moment(record?.createdAt).format('DD-MM-YYYY HH:MM:ss') : null}</span>
          </Flex>
        )
      }
    },
  ];

  if (!posted) {
    transactionCol.push({
      title: 'Action',
      align: "right",
      dataIndex: '',
      render(record) {
        return (
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <DeleteFilled
              style={{
                fontSize: "25px",
                cursor: "pointer",
                color: "#cd1437",
              }}
              onClick={() => {
                Modal.confirm({
                  title: 'Delete Transaction',
                  centered: true,
                  content: `Are you sure you want to delete this transaction?`,
                  onOk: () => deleteTransaction(record.id),
                  okText: 'Delete',
                  cancelText: 'Cancel',
                  width: 600,
                  okButtonProps: { size: "large" },
                  cancelButtonProps: { size: "large" },
                });
              }}
            />
          </div>
        );
      },
    });
  }

  const deleteTransaction = async (id) => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/stock/delete-po-transaction`, {
        method: "DELETE",
        body: JSON.stringify({ id: id })

      });
      if (res?.ack) {
        showMessage('success', res?.message);
        setNewStock({
          product: "",
          product_id: '',
          location: "",
          location_id: '',
          quantity: "",
          productText: '',
          locationText: '',
          productStatus: null,
          locationStatus: null,
          expiry_date: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
          fullPallet: false,
          remaining_quantity_check: false,
          fullPalletShow: true
        });
        setSelectedItem(null);
        setModalVisible(false);
        handleSearch();
      } else {
        showMessage('error', res?.message);
        hideLoading(layoutDispatch);
      }
    } catch (err) {
      console.log(err);
      showMessage('error', err?.message);
      hideLoading(layoutDispatch);
    }
    // finally {
    //   hideLoading(layoutDispatch);
    // }
  };


  const locationBlur = () => {
    if (!newStock?.product_id) {
      showMessage('error', 'Please select a product first')
      setNewStock({ ...newStock, location: '' })
      return;
    }
    const selectedProduct = products?.find((pro) => pro?.netsuite_id == newStock?.product_id)
    const productLocations = selectedProduct?.product_locations
      ? selectedProduct.product_locations.split(',').map((id) => Number(id.trim()))
      : [];

    if (!newStock?.location) {
      setNewStock({ ...newStock, locationStatus: 'error', locationText: 'No Location Entered' })
      return;
    } else {
      const selectedLocation = locations?.find((loc) => loc?.code == newStock?.location)
      if (selectedLocation?.id && productLocations?.includes(selectedLocation?.id)) {
        setNewStock({ ...newStock, location_id: selectedLocation?.id, locationStatus: 'success', locationText: selectedLocation?.title })
      } else {
        setNewStock({ ...newStock, locationStatus: 'error', locationText: 'Location not found' })
      }

    }
  };

  const productBlur = () => {
    if (!newStock?.product) {
      setNewStock({ ...newStock, productStatus: 'error', productText: 'No Product Entered' })
      return;
    } else {
      const selectedProduct = products?.find((pro) => pro?.code == newStock?.product || pro?.barcode == newStock?.product);
      const matchedProduct = selectedItem?.product_netsuite_id == selectedProduct?.netsuite_id ? true : false;
      // get products locations array
      const productLocations = selectedProduct?.product_locations
        ? selectedProduct.product_locations.split(',').map((id) => Number(id.trim()))
        : [];
      const matchedLocations = locations.filter(location =>
        productLocations.includes(location.id)
      );

      if (selectedProduct && matchedProduct) {
        setNewStock({ ...newStock, product_id: selectedProduct?.netsuite_id, productStatus: 'success', productText: selectedProduct?.name })
        setSelectedProductLocations(matchedLocations);

      } else {
        setNewStock({ ...newStock, productStatus: 'error', productText: 'Invalid Product', product: '', product_id: '' })
      }
    }
  };

  const productSelectValueChange = (val, isScanned) => {
    console.log('productSelectValueChange', val, isScanned);
  
    const selectedProduct = isScanned
      ? products?.find((pro) => pro?.code === val || pro?.barcode === val)
      : products?.find((pro) => pro?.netsuite_id === val);
  
    const matchedProduct = selectedItem?.product_netsuite_id === selectedProduct?.netsuite_id;
  
    if (selectedProduct && matchedProduct) {
    const productLocations = selectedProduct?.product_locations
        ? selectedProduct.product_locations.split(',').map((id) => Number(id.trim()))
        : [];
      const matchedLocations = locations.filter(location =>
        productLocations.includes(location.id)
      );
      setNewStock({ ...newStock, product_id: selectedProduct?.netsuite_id, productStatus: 'success', productText: selectedProduct?.name })
      setSelectedProductLocations(matchedLocations);
  
        } else {
        setSelectedProductLocations([]);
        setNewStock({ ...newStock, productStatus: 'error', productText: 'Invalid Product', product: '', product_id: '' })

          showMessage('error', 'Invalid Product Selected');
        }
  };

  const locationSelectValueChange = (val, isScanned) => {
    console.log('locationSelectValueChange', val, isScanned);
    if (!newStock?.product_id) {
      showMessage('error', 'Please select a product first')
      setNewStock({ ...newStock, location_id: null })
      return;
    }
    if (isScanned) {
      const matched = locations?.find(item => item.code === val);
      if (matched) {
        setNewStock({ ...newStock, location_id: matched.id });
      } else {
        showMessage('error', "No matching location");
      }
    } else {
      setNewStock({ ...newStock, location_id: val });
    }
  };

  console.log(newStock, 'newStock');



  const postStockData = async () => {
    showLoading(layoutDispatch);
    const dataToSend = {
      id: recievedData[0]?.id,
    }
    try {
      const res = await Auth.fetch(`/stock/post-new-stock`, {
        method: "POST",
        body: JSON.stringify(dataToSend)
      });
      if (res?.ack) {
        showMessage('success', res?.message);
        handleSearch()
        // navigate("/stocks");
      } else {
        showMessage('error', res?.message);
        hideLoading(layoutDispatch);

      }

    } catch (err) {
      console.log(err);
      showMessage('error', 'Something went wrong');
      hideLoading(layoutDispatch);

    }
    // finally {
    //   hideLoading(layoutDispatch);
    // }
  };

    const infoItems = [
      {
        label: 'Supplier',
        value: `${detailsPO?.supplier_code || ''} - ${detailsPO?.supplier_name || ''}`,
        type: 'text', 
        icon: <UserOutlined style={{ color: "#52c41a" }} />,
        
      },
      {
        label: 'Order Date',
        value: detailsPO?.posting_date ? dayjs(detailsPO?.posting_date).format('DD-MM-YYYY') : 'N/A',
        type: 'text',
        icon: <CalendarOutlined style={{ color: "#fa541c" }} />,

      },
      {
        label: 'Receive By Date',
        value: detailsPO?.received_date ? dayjs(detailsPO?.received_date).format('DD-MM-YYYY') : 'N/A',
        type: 'text',
        icon: <CalendarOutlined style={{ color: "#fa541c" }} />,
      },
    ]

    if(detailsPO?.received_by) {
      infoItems.push({
        label: 'Receipt Code',
        value: detailsPO?.receipt_code || 'N/A',
        type: 'text',
        icon: <FileDoneOutlined  style={{ color: "#1677ff" }}/>,
        
      })
    }

    const modalInfoItems = [
        {
          label: 'Total Qty',
          value: selectedItem?.batch_quantity,
          type: 'text', 
          icon: <NumberOutlined style={{ color: "#1677ff" }} />,
          color: '#1677ff'
        },
        {
          label: 'Remaining Qty',
          value: selectedItem?.remaining_quantity > 0 ? selectedItem?.remaining_quantity : 0,
          type: 'text', 
          icon: <NumberOutlined style={{ color: "#1677ff" }} />,
          color: selectedItem?.remaining_quantity > 0 ?  'red' : '#1677ff'
        },
        {
              label: "Batch Code",
              value: selectedItem?.batch_code,
              icon: <TagOutlined style={{ color: "#1cfa1cff" }} />,
              type: 'text',
        
            },
            {
              label: "Supplier Batch Code",
              value: selectedItem?.supplier_batch_code,
              icon: <TagOutlined style={{ color: "#1cfa1cff" }} />,
              type: 'text',
        
            },
            {
              label: "Batch Expiry",
              value:  selectedItem?.expiry_date ? dayjs(selectedItem?.expiry_date).format('DD-MM-YYYY') : '',
              icon: <CalendarOutlined style={{ color: "#fa541c" }} />,
              type: 'text',
        
            },
      ]

    const modalItemDetailInfo = [
      {
        label: 'Total Qty',
        value: selectedItem?.batch_quantity
      },
      {
        label: 'Remaining Qty',
        value: selectedItem?.remaining_quantity
      },
      {
        label: 'Batch Code',
        value: selectedItem?.batch_code
      },
      {
        label: 'Batch Expiry',
        value: selectedItem?.expiry_date ? dayjs(selectedItem?.expiry_date).format('DD-MM-YYYY') : ''
      },
      {
        label: 'Supplier Batch Code',
        value: selectedItem?.supplier_batch_code
      },
    ]

  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'center', marginBottom: '10px' }}>
        <h3 style={{ margin: 0 }}>New Stock</h3>
        <Flex gap={5}>
          {recievedData?.length > 0 && <Button type="primary" icon={<InfoCircleFilled />} onClick={getLocationsDetails}>Available Locations</Button>}
        
        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate("/stocks")}>Back</Button>
        </Flex>
      </div>

      <>
        <Flex justify="space-between" align="center" gap={10} style={{ marginBottom: '16px' }} wrap>
          <Flex gap="small">
            <ScanInput onValueChange={handleValueChange} value={documentNumber} placeholder={'Search Document'} autoFocus={true} length="100%" />
            <Button type="primary" onClick={handleSearch}>Search</Button>
          </Flex>
          <Flex align="center">
            {detailsPO?.received_by > 0 && (
              <CustomTag label="Received" />
            )}
            {
              posted && (
                <CustomTag label="Posted" color="red" style={{ margin: 0 }}/>
              )
            }
          </Flex>
        </Flex>


        {
          detailsPO != null && (
            // <InfoCards items={infoItems} />
            <DetailsGrid infoItems={infoItems}/>
          )
        }

        <div style={{ marginTop: "20px" }}>
          <Table
            columns={dataCol}
            dataSource={recievedData}
            pagination={false}
            scroll={{ x: 'max-content'}}
            rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
          />
        </div>
        {
          recievedData?.length > 0 && (
            <>{
              (!posted) && (
                <Flex justify="end" gap={5} style={{ marginTop: "20px" }}>
                  <Button type="primary" size="large" disabled={isAnyQtyRemaining || posted}
                    //  onClick={postStockData}
                    onClick={() => {
                      Modal.confirm({
                        title: 'Post Order',
                        centered: true,
                        content: `Are you sure to post this order? This action cannot be undone.`,
                        onOk: () => postStockData(),
                        okText: 'Post',
                        cancelText: 'Cancel',
                        width: 600,
                        okButtonProps: { size: "large" },
                        cancelButtonProps: { size: "large" },
                      });
                    }}
                  >Post</Button>
                </Flex>
              )
            }
            </>

          )
        }


        <Modal width={'70vw'} title={`New Stock Details: ${selectedItem?.product_code} - ${selectedItem?.product_name}`}
          open={modalVisible}
          onCancel={handleModalCancel}
          okButtonProps={{ style: { display: "none" } }}
          cancelButtonProps={{ style: { display: 'none' } }}
          style={{ top: 20}}
        >
          <Divider />
          {/* <InfoCards items={modalItemDetailInfo} maxColumns={3} /> */}
          <DetailsGrid infoItems={modalInfoItems} />
          {
            selectedItem?.remaining_quantity > 0 && (
              <>
                <Row style={{ marginBottom: "10px" }}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <Text>Product</Text>
                    {/* <Flex align="center" gap="small">
                      <ScanInput onValueChange={productValueChange} value={newStock?.product} placeholder="Product" size={'large'} onBlur={productBlur} />
                      <Text type={newStock.productStatus == "error" ? "danger" : newStock.productStatus == "success" ? "success" : ""}>
                        {newStock.productText}
                      </Text>
                    </Flex> */}
                    <ProductScanSelect
                      onValueChange={productSelectValueChange}
                      value={newStock?.product_id}
                      options={products} placeholder="Product"
                      size="large"
                      length={'100%'}
                      productRef={productRef}
                    />
                  </Col>
                </Row>
                {
                  newStock?.product_id && (
                    <Row style={{ marginBottom: "10px" }}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <Text>Location</Text>
                    <ScanSelect onValueChange={locationSelectValueChange} value={newStock?.location_id} options={selectedLocations} placeholder="Location" size="large" length={'100%'} capacityCheck={true} />
                  </Col>
                </Row>
                  )
                }
                {
                  newStock?.location_id && (
                    <Row >
                  <Col>
                    <Text>Quantity</Text>
                    <Flex align="center" gap="small">
                      <Input size="large" type='number' value={newStock?.quantity}
                        onChange={(e) => {
                          // const newQty = e.target.value
                          const raw = e.target.value;
                          const newQty = /^\d*$/.test(raw) ? raw.replace(/^0+(?=\d)/, "") : '1';
                          const selectedProduct = products?.find((pro) => pro?.netsuite_id == newStock?.product_id);
                          const fullPalletQty = selectedProduct?.cases_in_pallets;
                          // if (newQty < 0) {
                          //   showMessage('error', 'Quantity cannot be negative');
                          //   return;
                          // }
                          if (newQty > fullPalletQty) {
                            showMessage('error', 'Quantity cannot be grater than pallet capacity');
                            return;
                          }
                          const remainingQty = selectedItem?.remaining_quantity;
                          if (newQty > remainingQty) {
                            showMessage('error', `Quantity cannot be greater than ${remainingQty}`)
                            return;
                          } else {
                            setNewStock({ ...newStock, quantity: newQty })
                          }
                        }
                        }
                        style={{ width: "290px" }} placeholder="Enter Quantity" />
                        {
                          newStock?.remainQtyShow && (
                            <Checkbox
                        checked={newStock?.remaining_quantity_check}
                        style={{ fontSize: '16px' }}
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          const qtyRemaing = selectedItem?.remaining_quantity;
                          const selectedProduct = products?.find((pro) => pro?.netsuite_id == newStock?.product_id);
                          const fullPalletQty = selectedProduct?.cases_in_pallets;

                          if (isChecked) {
                            if (!newStock?.product_id) {
                              showMessage('error', 'Please select a product first');
                              return;
                            }

                            if ( qtyRemaing > fullPalletQty) {
                            // showMessage('error', 'Remaining quantity should be less than pallet capacity')
                            return;
                          } else {

                            setNewStock({ ...newStock, quantity: qtyRemaing, remaining_quantity_check: isChecked });
                          }
                            
                          }
                          else {
                            setNewStock({ ...newStock, quantity: '', remaining_quantity_check: false });
                          }
                        }}
                      >
                        Remaining Quantity
                      </Checkbox>
                          )
                        }
                        {
                      newStock?.fullPalletShow && (
                        <Checkbox
                      checked={newStock?.fullPallet}
                      size="large"
                      style={{ marginTop: "10px" }}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        if (isChecked) {
                          if (!newStock?.product_id) {
                            showMessage('error', 'Please select a product first');
                            return;
                          }
                          const selectedProduct = products?.find((pro) => pro?.netsuite_id == newStock?.product_id);
                          const qtyRemaing = selectedItem?.remaining_quantity;
                          const fullPalletQty = selectedProduct?.cases_in_pallets;
                          if (fullPalletQty > qtyRemaing) {
                            showMessage('error', 'Remaining quantity is less than pallet quantity')
                            return;
                          } else {
                            setNewStock({ ...newStock, quantity: fullPalletQty, fullPallet: e.target.checked })
                          }
                        } else {
                          setNewStock({ ...newStock, quantity: '', fullPallet: false });
                        }

                      }
                      }
                    >
                      Full Pallet
                    </Checkbox>
                      )
                    }
                      
                    </Flex>
                    
                    
                  </Col>
                </Row>
                  )
                }
                
                <Flex justify="end" gap={5}>
                  <Button onClick={() => handleModalCancel()} >Cancel</Button>
                  {
                    (Number(selectedItem.batch_quantity) - Number(selectedItem?.quantityAdded) > 0) && (
                      <Button disabled={!newStock?.product_id} type="primary" onClick={() => handleModalOk()} >Save</Button>
                    )
                  }

                </Flex>


                <Divider />
              </>
            )
          }




          {
            stockTransactions?.length > 0 &&
            (
              <>
                <h3 style={{ margin: 0 }}>Transactions</h3>
                <Table
                  columns={transactionCol}
                  dataSource={stockTransactions}
                  pagination={false}
                  scroll={{ x: 'max-content' }}
                  rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
                />
              </>
            )
          }
        </Modal>
          <ProductInfoModal
          visible={modalVisibleProduct}
          onCancel={handleModalCancelProduct}
          selectedItemDetails={selectedProductDetails}
          selectedItems={selectedProductDetails?.productDetails}
            // selectedRecord={selectedRecord}
          />
          <LocationInfoModal
          visible={modalVisibleLocation}
          onCancel={handleModalCancelLocation}
          locationDetails={allLocations}
          />
      </>
    </>
  );
};

export default NewStock;
